import { Empty, Flex, Icon } from 'ui';

const ChatMessagesEmpty = () => (
  <Flex className="chat-messages-empty" justify="center">
    <Empty
      description={{
        subtitle: 'There are no messages yet. Send a message to start a conversation.',
        title: 'No messages yet',
      }}
      fitCenter
      image={<Icon icon="inbox-line" />}
    />
  </Flex>
);

export default ChatMessagesEmpty;
